import { jsx as _jsx } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { contentCollectionCustomFieldsSelector, setCustomFieldDateValueAction, setCustomFieldPlainTextValueAction, setCustomFieldValueAction, setCustomFieldValuesAction } from "@air/feature-content-collection/redux";
import { ContentCollectionManageSidebar } from "@air/feature-content-collection/ui";
import { useCallback } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { ContentCollectionCustomFieldDateInput } from "~/components/ContentCollection/ContentCollectionCustomFieldDateInput";
import { ContentCollectionCustomFieldMultiSelect } from "~/components/ContentCollection/ContentCollectionCustomFieldMultiSelect";
import { ContentCollectionCustomFieldPlainText } from "~/components/ContentCollection/ContentCollectionCustomFieldPlainText";
import { ContentCollectionCustomFieldSingleSelect } from "~/components/ContentCollection/ContentCollectionCustomFieldSingleSelect";
import { ContentCollectionSubmitButton } from "~/components/ContentCollection/ContentCollectionSubmitButton";
import { updateBoardCollectionCustomFieldsInAllClipsAction } from "~/store/boardCollection/actions";
import { boardCollectionClipsSelector } from "~/store/boardCollection/selectors";
export const ContentCollectionManageSidebarWrapper = ()=>{
    const dispatch = useDispatch();
    const clips = useSelector(boardCollectionClipsSelector);
    const customFields = useSelector(contentCollectionCustomFieldsSelector);
    const renderCustomField = useCallback((param)=>{
        let { customField, disabled } = param;
        switch(customField.type.title){
            case CustomFieldTypeName.singleSelect:
                {
                    var _customFields_find;
                    return /*#__PURE__*/ _jsx(ContentCollectionCustomFieldSingleSelect, {
                        clips: Object.values(clips),
                        customField: customField,
                        disabled: disabled,
                        onSuccess: (param)=>{
                            let { customFieldWithValues, values } = param;
                            batch(()=>{
                                dispatch(updateBoardCollectionCustomFieldsInAllClipsAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        value: values ? values[0] : null
                                    }
                                }));
                                dispatch(setCustomFieldValueAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        value: values ? values[0] : null
                                    }
                                }));
                            });
                        },
                        value: (_customFields_find = customFields.find((param)=>{
                            let { id } = param;
                            return id === customField.id;
                        })) === null || _customFields_find === void 0 ? void 0 : _customFields_find.value
                    });
                }
            case CustomFieldTypeName.multiSelect:
                {
                    var _customFields_find1;
                    return /*#__PURE__*/ _jsx(ContentCollectionCustomFieldMultiSelect, {
                        clips: Object.values(clips),
                        customField: customField,
                        disabled: disabled,
                        onSuccess: (param)=>{
                            let { customFieldWithValues, values } = param;
                            batch(()=>{
                                dispatch(updateBoardCollectionCustomFieldsInAllClipsAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        values: values !== null && values !== void 0 ? values : null
                                    }
                                }));
                                dispatch(setCustomFieldValuesAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        values: values !== null && values !== void 0 ? values : null
                                    }
                                }));
                            });
                        },
                        values: (_customFields_find1 = customFields.find((param)=>{
                            let { id } = param;
                            return id === customField.id;
                        })) === null || _customFields_find1 === void 0 ? void 0 : _customFields_find1.values
                    });
                }
            case CustomFieldTypeName.plainText:
                {
                    var _customFields_find2;
                    return /*#__PURE__*/ _jsx(ContentCollectionCustomFieldPlainText, {
                        assetIds: Object.values(clips).map((param)=>{
                            let { assetId } = param;
                            return assetId;
                        }),
                        customField: customField,
                        disabled: disabled,
                        onSuccess: (param)=>{
                            let { customFieldWithValues, value } = param;
                            batch(()=>{
                                dispatch(updateBoardCollectionCustomFieldsInAllClipsAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        plainTextValue: value
                                    }
                                }));
                                dispatch(setCustomFieldPlainTextValueAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        plainTextValue: value
                                    }
                                }));
                            });
                        },
                        value: (_customFields_find2 = customFields.find((param)=>{
                            let { id } = param;
                            return id === customField.id;
                        })) === null || _customFields_find2 === void 0 ? void 0 : _customFields_find2.plainTextValue
                    });
                }
            case CustomFieldTypeName.date:
                {
                    var _customFields_find3;
                    return /*#__PURE__*/ _jsx(ContentCollectionCustomFieldDateInput, {
                        assetIds: Object.values(clips).map((param)=>{
                            let { assetId } = param;
                            return assetId;
                        }),
                        customField: customField,
                        disabled: disabled,
                        onSuccess: (param)=>{
                            let { customFieldWithValues, date } = param;
                            batch(()=>{
                                dispatch(updateBoardCollectionCustomFieldsInAllClipsAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        dateValue: date
                                    }
                                }));
                                dispatch(setCustomFieldDateValueAction({
                                    customField: {
                                        ...customFieldWithValues,
                                        dateValue: date
                                    }
                                }));
                            });
                        },
                        value: (_customFields_find3 = customFields.find((param)=>{
                            let { id } = param;
                            return id === customField.id;
                        })) === null || _customFields_find3 === void 0 ? void 0 : _customFields_find3.dateValue
                    });
                }
            default:
                return null;
        }
    }, [
        customFields,
        clips,
        dispatch
    ]);
    return /*#__PURE__*/ _jsx(ContentCollectionManageSidebar, {
        renderCustomField: renderCustomField,
        renderSubmitButton: ()=>/*#__PURE__*/ _jsx(ContentCollectionSubmitButton, {})
    });
};
